import React, { useEffect, useRef } from 'react';

interface AdBodyFooterProps {
  className?: string;
}

const AdBodyFooter: React.FC<AdBodyFooterProps> = ({ className }) => {
  const adContainerRef = useRef<HTMLDivElement>(null);
  const isScriptInjected = useRef(false);

  useEffect(() => {
    if (isScriptInjected.current || !adContainerRef.current) return;
    
    // Create and inject the provider script
    const providerScript = document.createElement('script');
    providerScript.async = true;
    providerScript.type = 'application/javascript';
    providerScript.src = 'https://a.magsrv.com/ad-provider.js';
    
    // Create the ins element
    const insElement = document.createElement('ins');
    insElement.className = 'eas6a97888e6';
    insElement.setAttribute('data-zoneid', '5619438');
    insElement.setAttribute('data-keywords', 'tattoo,design,art,ink,tattooart,ai,artificialintelligence,bodyart,nailart,naildesign');
    
    // Create the initialization script
    const initScript = document.createElement('script');
    initScript.textContent = '(AdProvider = window.AdProvider || []).push({"serve": {}});';
    
    // Append all elements to the container
    adContainerRef.current.appendChild(providerScript);
    adContainerRef.current.appendChild(insElement);
    adContainerRef.current.appendChild(initScript);
    
    isScriptInjected.current = true;
    
    // Cleanup function
    return () => {
      if (adContainerRef.current) {
        adContainerRef.current.innerHTML = '';
      }
      isScriptInjected.current = false;
    };
  }, []);

  return (
    <div className={`w-full py-6 ${className || ''}`}>
      <div 
        ref={adContainerRef} 
        className="ad-body-footer max-w-4xl mx-auto flex justify-center items-center"
      />
    </div>
  );
};

export default AdBodyFooter;